import { createSelector } from '@ngrx/store';

import { PopularPlacesState } from '@hotels/hotels-home/store/reducers/popular-places.reducer';
import { HotelsHomeModuleState } from '@hotels/hotels-home/store/state/hotels-home-module.state';
import { hotelsHomeRootSelector } from '@hotels/hotels-home/store/selectors/hotels-home-root.selector';

export const getHotelsHomeState = createSelector(
  hotelsHomeRootSelector,
  (state: HotelsHomeModuleState) => state.popularPlaces
);

export const selectPopularPlaces = createSelector(getHotelsHomeState, (state: PopularPlacesState) => state);
